module.exports = __webpack_public_path__ + "static/media/product.bc19f844.svg";